import * as actionTypes from 'store/actions/actionTypes';

const initState = {
  loading: false,
  notifLoading: false,
  promos: [],
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PROMOS_START:
      return { ...state, loading: true };

    case actionTypes.FETCH_PROMO_START:
      return { ...state, loading: true };

    case actionTypes.FETCH_PROMOS_END:
      return {
        ...state,
        loading: false,
        promos: action.data.promos,
      };

    case actionTypes.FETCH_PROMO_END:
      return {
        ...state,
        loading: false,
        promos: replacePromo(state.promos, action.data),
      };

    case actionTypes.DELETE_PROMODUCT:
      return {
        ...state,
        loading: true,
        promos: removePromoduct(state.promos, action.data),
      };

    case actionTypes.NOTIFY_PROMO_START:
      return {
        ...state,
        notifLoading: true,
      };
    case actionTypes.NOTIFY_PROMO_END:
      return {
        ...state,
        notifLoading: false,
        promos: updateNotificationCount(state.promos, action.id),
      };
    case actionTypes.UPDATE_HIGHLIGHTED_PROMOS:
      return {
        ...state,
        loading: false,
        promos: replacePromos(state.promos, action.data),
      };
    default:
      return state;
  }
};

const updateNotificationCount = (promos, id) => {
  const newPromos = promos.map(promo => ({ ...promo }));
  let idx = newPromos.findIndex(p => p.id === id);
  newPromos[idx].notif_count = newPromos[idx].notif_count + 1 || 1;
  return newPromos;
};

const removePromoduct = (promos, data) => {
  const { promo_id, product_id } = data;
  var idx = promos.findIndex(p => p.id === promo_id);
  var thisPromo = promos[idx];
  thisPromo.product_ids = thisPromo.product_ids.filter(id => id !== product_id);
  promos[idx] = thisPromo;

  return promos;
};

const replacePromos = (promos, data) => {
  const orders = {};
  const ids = (data.promos || []).map(v => {
    orders[v.id] = v.highlight_order;
    return v.id;
  });

  return promos.map(promo => {
    if (ids.includes(promo.id)) {
      return { ...promo, highlighted: true, highlight_order: orders[promo.id] };
    } else {
      return { ...promo, highlighted: false, highlight_order: null };
    }
  });
};

const replacePromo = (promos, data) => {
  const { promo } = data;

  var idx = promos.findIndex(p => p.id === promo.id);
  promos[idx] = promo;

  return promos;
};



// WEBPACK FOOTER //
// ./src/store/reducers/promo.js